import React, { useState } from 'react';
import { Container, Row, Col, Label, Dropdown, DropdownMenu, DropdownToggle } from 'reactstrap';

function example() {
    return <Container>
        <Row>
            <Col>
                <Label>An Error Occured</Label>
            </Col>
        </Row>
    </Container>
}

const CustomDropDownView = (props) => {

    const [internalOpen, setInternalOpen] = useState(false);

    const isControlled = props.isOpen !== undefined && props.toggle !== undefined
    const isOpen = isControlled ? props.isOpen : internalOpen
    const toggle = isControlled ? props.toggle : () => setInternalOpen(prevState => !prevState);

    return (
          <Dropdown isOpen={isOpen} toggle={toggle}>
            <DropdownToggle caret size={props.size} color={props.color}
                style={props.toggleStyle}>
              {props.toggleLabel !== undefined ? props.toggleLabel : (props.name || "Name")}
            </DropdownToggle>
            <DropdownMenu container="body"
                style={{
                    'maxHeight': '400px',
                    'overflowY': 'auto',
                    ...props.menuStyle,
                }}>
              {props.view || example()}
            </DropdownMenu>
          </Dropdown>
    )
}

export default CustomDropDownView;
